import type { ReactNode } from "react";

import { cn } from "@flare/ui";

export function StepContent({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={cn("px-5 md:px-8", className)}>{children}</div>;
}
